import { Maximize, Minimize } from 'lucide-react';
import type { usePdfFullscreen } from './usePdfFullscreen';

export function StudyPdfFullscreenButton({
  control,
}: {
  control: ReturnType<typeof usePdfFullscreen>;
}) {
  return (
    <button
      ref={control.buttonRef}
      type="button"
      aria-label={control.active ? 'Exit PDF fullscreen' : 'Enter PDF fullscreen'}
      aria-pressed={control.active}
      disabled={control.pending}
      onClick={() => void control.toggle()}
      className="btn-pill-secondary min-h-11 gap-2 px-4 py-2 text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-sky"
    >
      {control.active ? (
        <Minimize className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Maximize className="h-4 w-4" aria-hidden="true" />
      )}
      {control.active ? 'Exit fullscreen' : 'Fullscreen'}
    </button>
  );
}
